module.exports = new __parcel__URL__("product1.ced5abaf.jpg").toString();